export const MATERIAL_ICONS_BASE =
  'https://raw.githubusercontent.com/mui/material-ui/master/packages/mui-icons-material/material-icons'
